<template>
  <div class="modal-out">
    <div class="modal" style="width: 500px;">

      <div class="modal-header">
        <div class="title">绑定</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="min-height: auto">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="选择老人" required prop="userName">
                  <el-input v-model="addForm.userName" placeholder="选择老人" disabled>
                    <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="摄像头序列号" required prop="sn">
                  <el-input v-model="addForm.sn" placeholder="输入序列号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="摄像头验证码" required prop="yzm">
                  <el-input v-model="addForm.yzm" placeholder="输入验证码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="通道号" required prop="tdh">
                  <el-input v-model="addForm.tdh" placeholder="输入通道号"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </el-form>

      </div>

      <div class="modal-footer">
        <el-button type="default" @click="closeSelf" style="margin-right: 10px">取消</el-button>
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>

    </div>
    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></GetElderly>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import GetElderly from "@/views/Elderly/Comm/ElderlyGov";

export default {
  name: 'Add',
  props:['setmealList'],
  data() {
    return {
      loading: false,
      showModalGetElderly: false,
      addForm:{
        timeStr:timeStr,
        sign:'',
        plateform:'shop',
        userCode:'',
        userName:'',
        sn:'',
        yzm:'',
        tdh:'',
      },
      rules:{
        sn:[
          { required: true, message: '输入序列号', trigger: 'blur' },
        ],
        yzm:[
          { required: true, message: '输入验证码', trigger: 'blur' },
        ],
        tdh:[
          { required: true, message: '输入通道号', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ]
      }
    }
  },
  components:{
    GetElderly
  },
  methods: {
    init(){
      this.$refs.addForm.resetFields();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },

    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init();
    },
    setElderly(row){
      this.addForm.userCode=row.userCode;
      this.addForm.userName = row.name;
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceCamera/Add2",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$message({type: 'success', message: '绑定成功'});
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }
}


</script>



<style lang="scss" scoped>
</style>
